import { assertNever } from '@/utils/assertNever'
import { ApproveDelegationActionRow } from '../../flavours/approve-delegation/ApproveDelegationActionRow'
import { ApproveActionRow } from '../../flavours/approve/ApproveActionRow'
import { BridgeActionRow } from '../../flavours/bridge/BridgeActionRow'
import { BorrowActionRow } from '../../flavours/borrow/BorrowActionRow'
import { ClaimMarketRewardsActionRow } from '../../flavours/claim-market-rewards/ClaimMarketRewardsActionRow'
import { DepositActionRow } from '../../flavours/deposit/DepositActionRow'
import { PermitActionRow } from '../../flavours/permit/PermitActionRow'
import { RepayActionRow } from '../../flavours/repay/RepayActionRow'
import { SetUseAsCollateralActionRow } from '../../flavours/set-use-as-collateral/SetUseAsCollateralActionRow'
import { SetUserEModeActionRow } from '../../flavours/set-user-e-mode/SetUserEModeActionRow'
import { WithdrawActionRow } from '../../flavours/withdraw/WithdrawActionRow'
import { ActionHandler } from '../../logic/types'
import { ActionRowVariant } from '../action-row/types'
import { IsolatedWithdrawActionRow } from '../../flavours/isolated-withdraw/IsolatedWithdrawActionRow'
import { IsolatedLendWithdrawActionRow } from '../../flavours/isolated-lend-withdraw/IsolatedLendWithdrawActionRow'
import { IsolatedLendDepositActionRow } from '../../flavours/isolated-lend-deposit/IsolatedLendDepositActionRow'
import { IsolatedDepositActionRow } from '../../flavours/isolated-deposit/IsolatedDepositActionRow'
import { IsolatedBorrowActionRow } from '../../flavours/isolated-borrow/IsolatedBorrowActionRow'
import { IsolatedRepayActionRow } from '../../flavours/isolated-repay/IsolatedRepayActionRow'
import { VaultDepositActionRow } from '../../flavours/vault-deposit/VaultDepositActionRow'
import { VaultWithdrawActionRow } from '../../flavours/vault-withdraw/VaultWIthdrawActionRow'
import { WrapActionRow } from '../../flavours/wrap/WrapActionRow'
import { Permit2SignActionRow } from '../../flavours/permit2-sign/Permit2SignActionRow'

interface ActionsGridProps {
  actionHandlers: ActionHandler[]
  variant: ActionRowVariant
}

export function ActionsGrid({ actionHandlers, variant }: ActionsGridProps) {
  return (
    <div className="grid grid-cols-[auto_auto_1fr_auto] gap-x-4 md:grid-cols-[auto_auto_auto_1fr_auto]">
      {actionHandlers.map((handler, index) => {
        const props = {
          index: index + 1,
          actionHandlerState: handler.state,
          onAction: handler.onAction,
          variant,
        }

        switch (handler.action.type) {
          case 'approve':
            return <ApproveActionRow action={handler.action} key={index} {...props} />
          case 'approveDelegation':
            return <ApproveDelegationActionRow action={handler.action} key={index} {...props} />
          case 'borrow':
            return <BorrowActionRow action={handler.action} key={index} {...props} />
          case 'deposit':
            return <DepositActionRow action={handler.action} key={index} {...props} />
          case 'permit':
            return <PermitActionRow action={handler.action} key={index} {...props} />
          case 'repay':
            return <RepayActionRow action={handler.action} key={index} {...props} />
          case 'setUseAsCollateral':
            return <SetUseAsCollateralActionRow action={handler.action} key={index} {...props} />
          case 'setUserEMode':
            return <SetUserEModeActionRow action={handler.action} key={index} {...props} />
          case 'withdraw':
            return <WithdrawActionRow action={handler.action} key={index} {...props} />
          case 'claimMarketRewards':
            return <ClaimMarketRewardsActionRow action={handler.action} key={index} {...props} />
          case 'bridgeToHyperEVM':
          case 'bridgeToHyperCore':
            return <BridgeActionRow action={handler.action} key={index} {...props} />
          case 'isolatedWithdraw':
            return <IsolatedWithdrawActionRow action={handler.action} key={index} {...props} />
          case 'isolatedLendWithdraw':
            return <IsolatedLendWithdrawActionRow action={handler.action} key={index} {...props} />
          case 'isolatedLendDeposit':
            return <IsolatedLendDepositActionRow action={handler.action} key={index} {...props} />
          case 'isolatedDeposit':
            return <IsolatedDepositActionRow action={handler.action} key={index} {...props} />
          case 'isolatedBorrow':
            return <IsolatedBorrowActionRow action={handler.action} key={index} {...props} />
          case 'isolatedRepay':
            return <IsolatedRepayActionRow action={handler.action} key={index} {...props} />
          case 'vaultDeposit':
            return <VaultDepositActionRow action={handler.action} key={index} {...props} />
          case 'vaultWithdraw':
            return <VaultWithdrawActionRow action={handler.action} key={index} {...props} />
          case 'wrap':
            return <WrapActionRow action={handler.action} key={index} {...props} />
          case 'permit2Sign':
            return <Permit2SignActionRow action={handler.action} key={index} {...props} />
          default:
            assertNever(handler.action)
        }
      })}
    </div>
  )
}
